import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Card, CardHeader, CardTitle } from '@monigo/ui';
import { callFunction } from '../../lib/api/client.js';

interface KycQueueResp {
  items: Array<{ id: string }>;
}
interface TransfersResp {
  items: Array<{ amount_send: number; from_currency: string }>;
  total: number;
}

export function DashboardPage() {
  const { t } = useTranslation();
  const kycQ = useQuery({
    queryKey: ['admin', 'dashboard', 'kyc'],
    queryFn: () => callFunction<KycQueueResp>('admin-kyc-queue'),
  });
  const pendingQ = useQuery({
    queryKey: ['admin', 'dashboard', 'pending'],
    queryFn: () =>
      callFunction<TransfersResp>('admin-transfers-list', {
        query: { status: 'PENDING_PAYMENT', per_page: 1 },
      }),
  });

  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      <Stat title={t('dashboard.pendingKyc')} value={kycQ.data?.items.length ?? '—'} />
      <Stat title={t('dashboard.pendingTransfers')} value={pendingQ.data?.total ?? '—'} />
      <Stat title={t('dashboard.todayVolume', { currency: 'EUR' })} value="—" />
    </div>
  );
}

function Stat({ title, value }: { title: string; value: number | string }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm text-text-muted">{title}</CardTitle>
      </CardHeader>
      <div className="font-display text-3xl font-bold text-primary">{value}</div>
    </Card>
  );
}
